import { useState } from "react";
import StyleWrapper, {
    StyleContentWrapper,
    StyleFlexPrizes,
} from "./style";

export default ({setIsModalOpen}) => {
    return (
        <>
            <StyleWrapper>
                <StyleContentWrapper>
                    <StyleFlexPrizes>
                        <div>
                            <img
                                src="/assets/img/premio.png"
                                alt="Prêmios"
                            />
                        </div>
                        <div>
                            <img
                                src="/assets/img/premio-description.png"
                                alt="Prêmios"
                            />
                            <p>*limitado a um prêmio por CPF.</p>
                        </div>
                    </StyleFlexPrizes>
                    <div>
                        <p>
                            Período de participação: de 25/10/2025 a 25/01/2026.
                            Serão considerados válidos apenas os test drives
                            realizados nas concessionárias participantes e que
                            atendam aos parâmetros descritos no regulamento,
                            limitado a um prêmio por CPF. Certificado de
                            autorização N.° 04.045460/2025.
                        </p>
                    </div>
                </StyleContentWrapper>
            </StyleWrapper>
        </>
    );
};
